import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ShortenedLinks() {
    const [links, setLinks] = useState([]);
    const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://urlshortener-serverside.onrender.com/api';

    useEffect(() => {
        // Fetch shortened links from the backend
        async function fetchShortenedLinks() {
            try {
                const response = await axios.get(`${BASE_URL}/links`, {
                    params: { compact: 1, limit: 50 }
                });
                setLinks(response.data);
            } catch (error) {
                console.error('Error fetching shortened links:', error);
            }
        }

        fetchShortenedLinks();
    }, []);

    return (
        <div>
            <h2>Shortened Links</h2>
            <ul>
                {links.map(link => (
                    <li key={link.shortUrl}>
                        <p>Short URL: {link.shortUrl}</p>
                        <p>Long URL: {link.longUrl}</p> {/* Display longUrl */}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ShortenedLinks;
